var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0623 5.95246L13.774 6.64613C14.0753 6.93985 14.0753 7.4148 13.774 7.70539L7.545 13.7797C7.24365 14.0734 6.75635 14.0734 6.45821 13.7797L0.226013 7.70539C-0.0753379 7.41167 -0.0753379 6.93673 0.226013 6.64613L0.937715 5.95246C1.24227 5.65562 1.73918 5.66187 2.03733 5.96496L5.71766 9.73016L5.71766 0.749916C5.71766 0.334338 6.06068 0 6.48706 0L7.51294 0C7.93932 0 8.28234 0.334338 8.28234 0.749916L8.28234 9.73016L11.9627 5.96496C12.2608 5.65874 12.7577 5.65249 13.0623 5.95246Z",
    fill: "#F26335"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic-arrow-down.f81dc57c730f36cafd243efb2db77fd1.svg";
export { ForwardRef as ReactComponent };